import {ReactElement} from "react";
import {RendererProps} from "../RendererProps";
import {ensureNotObject, formatYearAndVersionType} from "../common";
import * as common from "../styles/common.module.scss";

const PERCENT_KEYS = [
    "percentMonth0",
    "percentMonth1",
    "percentMonth2",
    "percentMonth3",
    "percentMonth4",
    "percentMonth5",
    "percentMonth6",
    "percentMonth7",
    "percentMonth8",
    "percentMonth9",
    "percentMonth10",
    "percentMonth11"
];

export function RenderBulkUpdateAccPercentageDriverAssumptions(props: RendererProps): ReactElement {
    const item = props.variables["item"];
    if(typeof item !== "object" || item === null) {
        return <></>;
    }

    const year = item["year"];
    const versionType = item["versionType"];

    const vals: ReactElement[] = [];
    for(let i = 0; i < 12; i++) {
        const percentKey = PERCENT_KEYS[i];

        if(!percentKey) {
            continue;
        }

        const percent = item[percentKey];
        if(percent === null || percent === undefined) {
            continue;
        }

        vals.push(<li key={`${i}`}>
            Month {i + 1}: {ensureNotObject(percent)}% of ALL ACCOUNTS
        </li>);
    }

    return <div>
        <div className={common.textHeader}>{formatYearAndVersionType(year, versionType)}</div>
        <ul>
            {vals}
        </ul>
    </div>;
}